module.exports = __webpack_public_path__ + "images/jsw-crossflow/chorizo.793d3eb97fe6c397aace.svg";